import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import { closeComponentsModal, createComponentAction } from '../store/package-designer.actions';
import {
  COMPONENT_TYPES_DESTINATIONS,
  COMPONENT_TYPES_SOURCES,
  COMPONENT_TYPES_TRANSFORMATIONS,
  COMPONENT_TYPES_WORKFLOWS,
  ComponentTypeItem,
} from '../../constants/component_types';
import { setComponent } from '../store/component.actions';
import { selectComponentsModalFlags } from '../store/package-designer.selectors';

@Component({
  selector: 'components-list',
  template: `
    <div class="modal-body">
      <div class="row components-list" *ngIf="componentsModalFlags$ | async as componentsModalFlags">
        <div class="col-sm-4 components-list-sources" *ngIf="componentsModalFlags.hasSources">
          <strong class="lead">{{ 'components-list.labels.sources' | translate }}</strong>
          <ul class="list-group">
            <li
              class="list-group-item"
              *ngFor="let source of sources"
              (click)="addComponentFromList(source)"
              [id]="source.componentType"
            >
              <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
                <use [attr.href]="'#icons-sprite_' + source.icon" class="designer-component-icon"></use>
              </svg>
              <span>{{ source.originalName }}</span>
            </li>
          </ul>
        </div>
        <div class="col-sm-4 components-list-transformations" *ngIf="componentsModalFlags.hasTransformations">
          <strong class="lead">{{ 'components-list.labels.transformations' | translate }}</strong>
          <ul class="list-group">
            <li
              class="list-group-item"
              *ngFor="let transformation of transformations"
              (click)="addComponentFromList(transformation)"
              [id]="transformation.componentType"
            >
              <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
                <use [attr.href]="'#icons-sprite_' + transformation.icon" class="designer-component-icon"></use>
              </svg>
              <span>{{ transformation.originalName }}</span>
            </li>
          </ul>
        </div>
        <div class="col-sm-4 components-list-destinations" *ngIf="componentsModalFlags.hasDestinations">
          <strong class="lead">{{ 'components-list.labels.destinations' | translate }}</strong>
          <ul class="list-group">
            <li
              class="list-group-item"
              *ngFor="let destination of destinations"
              (click)="addComponentFromList(destination)"
              [id]="destination.componentType"
            >
              <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
                <use [attr.href]="'#icons-sprite_' + destination.icon" class="designer-component-icon"></use>
              </svg>
              <span>{{ destination.originalName }}</span>
            </li>
          </ul>
        </div>
        <div class="col-sm-4 components-list-workflows" *ngIf="componentsModalFlags.hasWorkflow">
          <strong class="lead">{{ 'components-list.labels.task' | translate }}</strong>
          <ul class="list-group">
            <li
              class="list-group-item"
              *ngFor="let workflow of workflows"
              (click)="addComponentFromList(workflow)"
              [id]="workflow.componentType"
            >
              <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
                <use [attr.href]="'#icons-sprite_' + workflow.icon" class="designer-component-icon"></use>
              </svg>
              <span>{{ workflow.originalName }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  `,
})
export class ComponentsListComponent {
  componentsModalFlags$ = this.store.select(selectComponentsModalFlags);

  constructor(private store: Store<AppState>) {}

  sources = COMPONENT_TYPES_SOURCES;
  transformations = COMPONENT_TYPES_TRANSFORMATIONS;
  destinations = COMPONENT_TYPES_DESTINATIONS;
  workflows = COMPONENT_TYPES_WORKFLOWS;

  addComponentFromList(component: ComponentTypeItem) {
    this.store.dispatch(closeComponentsModal());
    this.store.dispatch(createComponentAction({ component }));
  }

  closeModal() {
    this.store.dispatch(closeComponentsModal());
  }
}
